import { render, staticRenderFns } from "./MfRadio.vue?vue&type=template&id=bf57eb94&scoped=true&"
import script from "./MfRadio.vue?vue&type=script&lang=js&"
export * from "./MfRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf57eb94",
  null
  
)

export default component.exports